import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

// Request interceptor
service.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

// Response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({ message: res.message || '请求失败', type: 'error', duration: 3000 })
      if (res.code === 401) {
        store.dispatch('user/logout')
        router.push('/login')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response ? error.response.status : 0
    if (status === 401) {
      store.dispatch('user/logout')
      router.push('/login')
    }
    // 优先读取后端返回的 message（如 IP 区域限制、参数校验等场景后端会返回 JSON 错误体）
    var serverMsg = error.response && error.response.data && error.response.data.message
    var displayMsg = serverMsg || error.message || '网络错误'
    Message({ message: displayMsg, type: 'error', duration: 3000 })
    return Promise.reject(new Error(displayMsg))
  }
)

export default service
